import { useCallback, useEffect, useMemo } from "react"
import { translate, type MessageKey } from "../i18n"
import { PLANNED_LANGUAGES, type LanguageDirection } from "../i18n/languages"
import { useLocaleStore } from "../store/localeStore"

export function useI18n() {
  const locale = useLocaleStore((state) => state.locale)
  const setLocale = useLocaleStore((state) => state.setLocale)
  const t = useCallback((key: MessageKey) => translate(key, locale), [locale])
  const direction = useMemo<LanguageDirection>(
    () => PLANNED_LANGUAGES.find((language) => language.code === locale)?.direction || "ltr",
    [locale],
  )

  useEffect(() => {
    const root = document.documentElement
    root.lang = locale
    root.dataset.bbLocale = locale
    root.dataset.bbTextDirection = direction
  }, [locale, direction])

  return { locale, direction, setLocale, t }
}
